import React from 'react';

const LoadingSpinner = ({ message = 'Loading...', size = 'medium', fullScreen = false }) => {
  const sizeClasses = {
    small: { spinner: 'w-6 h-6', text: 'text-sm' },
    medium: { spinner: 'w-10 h-10', text: 'text-base' },
    large: { spinner: 'w-16 h-16', text: 'text-lg' }
  };

  const { spinner, text } = sizeClasses[size] || sizeClasses.medium;

  const content = (
    <div className="text-center">
      <div className="inline-block">
        <div 
          className={`spinner ${spinner} border-4 border-blue-500 border-t-transparent rounded-full animate-spin`}
        ></div>
      </div>
      {message && (
        <p className={`text-gray-600 mt-3 ${text}`}>{message}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        {content}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      {content}
    </div>
  );
};

export default LoadingSpinner;
